var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"maps"},[_c('div',{staticClass:"map-head-text"},[_vm._v(_vm._s(_vm.address))]),_c('div',{staticClass:"maps-wrapper",style:('width:' + _vm.width + ';height:' + _vm.height + ';'),attrs:{"id":"map-container"}})])}
var staticRenderFns = []

export { render, staticRenderFns }